export default "__VITE_ASSET__B03F1oUm__"